import { Injectable } from "@angular/core";
import { ErrorMessageHandler } from "@smallstack/common-components";
import { Logger } from "@smallstack/core-common";
import { filterNullish } from "@smallstack/utils";
import { firstValueFrom } from "rxjs";
import { TranslationStore } from "../stores/translation.store";
import { ConsoleNotifier } from "./notifiers/console.notifier";
import { MaterialDialogNotifier } from "./notifiers/material-dialog.notifier";
import { MaterialSnackbarNotifier } from "./notifiers/material-snackbar.notifier";
import * as i0 from "@angular/core";
import * as i1 from "@smallstack/common-components";
import * as i2 from "./notifiers/material-snackbar.notifier";
import * as i3 from "./notifiers/material-dialog.notifier";
import * as i4 from "../stores/translation.store";
export class NotificationService {
    constructor(errorMessageHandler, materialSnackbarNotifier, materialDialogNotifier, translationStore) {
        this.errorMessageHandler = errorMessageHandler;
        this.translationStore = translationStore;
        this.console = new ConsoleNotifier();
        this.popup = materialDialogNotifier;
        this.notification = materialSnackbarNotifier;
    }
    getStandardCallback(errorMsg, successMsg) {
        if (errorMsg === undefined)
            errorMsg = "Error";
        if (successMsg === undefined)
            successMsg = "Successful";
        return (error, result) => {
            if (error !== undefined)
                void this.showStandardErrorPopup(error, errorMsg);
            else
                this.notification.success(successMsg + (result !== undefined ? ` [${result}]` : ""));
        };
    }
    showStandardErrorPopup(error, title, content) {
        Logger.error("NotificationService", "An Error occured: ", { title, error });
        if (!title)
            title = this.translationStore.translate("@@notifications.error.title");
        if (!content) {
            const handledErrorMessage = this.errorMessageHandler.handleMessage(error);
            let errorMessageString = this.translationStore.translate(handledErrorMessage, { showMissingKey: true });
            if (errorMessageString === undefined)
                errorMessageString = handledErrorMessage;
            this.popup.error(title, errorMessageString);
        }
        else
            this.popup.error(title, content);
    }
    setConsoleNotifier(notifier) {
        this.console = notifier;
    }
    setPopupNotifier(notifier) {
        this.popup = notifier;
    }
    setNotificationNotifier(notifier) {
        this.notification = notifier;
    }
    async handlePromise(promise, options = {}) {
        try {
            const returnValue = await promise;
            let message;
            if (options.successMsg)
                message = options.successMsg;
            else
                message = this.translationStore.translate("@@notifications.success.title", { showMissingKey: true });
            this.notification.success(message);
            return returnValue;
        }
        catch (e) {
            let message;
            if (options.errorMsg)
                message = options.errorMsg;
            else
                message = this.translationStore.translate("@@notifications.error.title", { showMissingKey: true });
            message = options.errorMsg;
            this.showStandardErrorPopup(e, message, options.errorMsgContent);
            if (!options || options.rethrowException === undefined || options.rethrowException === true)
                throw e;
        }
    }
    async handleObservable(observable, options = {}) {
        return this.handlePromise(firstValueFrom(observable.pipe(filterNullish())), options);
    }
}
NotificationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: NotificationService, deps: [{ token: i1.ErrorMessageHandler }, { token: i2.MaterialSnackbarNotifier }, { token: i3.MaterialDialogNotifier }, { token: i4.TranslationStore }], target: i0.ɵɵFactoryTarget.Injectable });
NotificationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: NotificationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: NotificationService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.ErrorMessageHandler }, { type: i2.MaterialSnackbarNotifier }, { type: i3.MaterialDialogNotifier }, { type: i4.TranslationStore }]; } });
